import React from 'react';
import { useLocation } from 'react-router-dom';

import Shield from '@gravity-ui/icons/Shield';
import i18n from '@yandex-int/i18n';
import { AliceIcon } from 'client/blocks/icons/AliceIcon';
import { AutoIcon } from 'client/blocks/icons/AutoIcon';
import { SmartHomeIcon } from 'client/blocks/icons/SmartHomeIcon';
import { SmartScreenIcon } from 'client/blocks/icons/SmartScreenIcon';
import { TvIcon } from 'client/blocks/icons/TvIcon';
import { LayoutNavLink } from 'client/blocks/LayoutNavLink/LayoutNavLink';
import { routes } from 'client/lib/routes';
import { Channel } from 'client/model/skill';
import {
    getCanViewAsAdmin,
    getIsYangoRequest,
    isInstallableAppChannel,
    showAppStoreUi,
    showAutoAppUi,
} from 'client/utils';
import * as skillCreation from 'i18n/SkillCreation';
import * as keyset from 'i18n/SkillsIndex';

import styles from './AppsIndex.module.scss';

interface Props {
    channel: Channel;
}

const t = i18n(keyset);
const tSkillCreation = i18n(skillCreation);

const ALL_AVAILABLE_SLUG = 'all-available-apps';

export const AppsIndexNavbar = ({ channel }: Props) => {
    const location = useLocation();

    const isAllAppsPage = location.pathname.includes(ALL_AVAILABLE_SLUG);

    const aliceSkillRedesignLink = getIsYangoRequest() ? null : (
        <LayoutNavLink
            to={routes.app.installableApps(Channel.AliceSkill)}
            icon={<AliceIcon />}
            isActive={channel === Channel.AliceSkill}
            label={t('alice-skills')}
        />
    );

    return (
        <nav className={styles.navLinks}>
            <div className={styles.navLinks__contentBlock}>
                {getCanViewAsAdmin() && isInstallableAppChannel(channel) ? (
                    <>
                        <LayoutNavLink
                            to={routes.app.allAppsByChannel(channel)}
                            icon={<Shield />}
                            label={t('all-available-apps')}
                            isActive={isAllAppsPage}
                        />
                        <LayoutNavLink
                            to={routes.app.installableApps(channel)}
                            isActive={!isAllAppsPage}
                            label={t('my-apps')}
                        />
                    </>
                ) : null}
            </div>
            <div className={styles.navLinks__contentBlock}>
                {showAppStoreUi() && (
                    <LayoutNavLink
                        to={routes.app.installableApps(Channel.TvApp)}
                        icon={<TvIcon />}
                        isActive={channel === Channel.TvApp}
                        label={t('tv-apps')}
                    />
                )}
                {showAutoAppUi() && (
                    <LayoutNavLink
                        to={routes.app.installableApps(Channel.AutoApp)}
                        icon={<AutoIcon />}
                        isActive={channel === Channel.AutoApp}
                        label={t('auto-apps')}
                    />
                )}
                {showAppStoreUi() && (
                    <LayoutNavLink
                        to={routes.app.installableApps(Channel.SmartScreenApp)}
                        icon={<SmartScreenIcon />}
                        isActive={channel === Channel.SmartScreenApp}
                        label={t('smart-screen-apps')}
                    />
                )}
                {aliceSkillRedesignLink}
                <LayoutNavLink
                    to={routes.app.installableApps(Channel.SmartHome)}
                    icon={<SmartHomeIcon />}
                    isActive={channel === Channel.SmartHome}
                    label={tSkillCreation('smart-home')}
                />
            </div>
        </nav>
    );
};
